import { SET_ERROR } from "../actions/types";

const INITIAL_STATE = {
    statusCode: null,
    statusText: null,
    message: null
};

const errorReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ERROR:
            return {
                ...state,
                statusCode: action.payload.statusCode,
                statusText: action.payload.statusText,
                message: action.payload.message
            };
        default:
            return state;
    }
};

export default errorReducer;